module.exports = __webpack_public_path__ + "img/home_middel_left_1.2d7c36df.png";